import styled from 'styled-components';
import {
  spacingHelper,
  paletteHelper,
  radiusHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { OutboundLink } from '../../../app-kit/components/OutboundLink/OutboundLink';
import { Stack } from '@property.com.au/ui-kit';

export const StyledStack = styled(Stack)`
  margin-right: ${spacingHelper('large')};
`;

export const HighlightedBox = styled.div`
  padding: ${spacingHelper('large')};
  border-radius: ${radiusHelper('medium')};
  background-color: ${paletteHelper('backgroundBlue')};
  margin-bottom: ${spacingHelper('extraLarge')};
`;

export const REALogo = styled.img`
  width: 15.04rem;
  height: 2rem;
  margin-top: ${spacingHelper('extraSmall')};
`;

export const HighlightedBoxTitle = styled.p`
  ${typographyHelper('subtitle02')};
  margin-bottom: ${spacingHelper('twoExtraSmall')};
`;

export const REALogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const InfoSection = styled.div`
  flex-grow: 1;
  > * {
    margin-bottom: ${spacingHelper('medium')};
  }
`;

export const Subtitle = styled.p`
  ${typographyHelper('subtitle02')};
`;

export const Paragraph = styled.p`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
`;

export const UntitledList = styled.ul`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
  list-style-position: inside;
  margin-left: ${spacingHelper('twoExtraSmall')};
`;

export const ListItem = styled.li`
  ${typographyHelper('body02')};
  color: ${paletteHelper('textSecondary')};
  list-style-type: disc;
`;

export const HelpOutboundLink = styled(OutboundLink)`
  font-weight: 400;
`;
